import { Component, Input, OnInit } from '@angular/core';
import moment from 'moment';
import { WfFeaturesService } from '@app/services/wf-features.service';
import { TourGuideService } from '@app/services/tour-guide.service';
import dummyData from '@app/assets/api-dummy-data.json';
import { Messages } from '@app/util/messages';
@Component({
  selector: 'app-feature-workflow-expand',
  templateUrl: './feature-workflow-expand.component.html',
  styleUrls: ['./feature-workflow-expand.component.scss']
})

export class FeatureWorkflowExpandComponent implements OnInit {

  /****************** Variable declaration ******************/
  workflowElementArray: any;
  getNoData = Messages.no_data; //for getting no data available message

  /****************** Input and Output decorators ******************/
  @Input() jobId!: string;

  /**
   * Constructor
   * @param featureWf 
   * @param guideService 
   */
  constructor(private featureWf: WfFeaturesService,
    private guideService: TourGuideService) {
  }

  /** ngOnInit */
  ngOnInit() {
    if (this.guideService.isStartTour) {
      this.workflowElementArray = dummyData.feature_workFlow.workFlowTableData
      return;
    }

    this.featureWf.getWfExeRes(this.jobId).subscribe((response: any) => {
      this.workflowElementArray = response.data.dbResp;
      this.workflowElementArray.map((ds: any) => ds.startTime = moment(ds.startTime).format('ddd MMM DD YYYY HH:mm:ss [GMT] Z'));
    });

  }
}

/**
 * **************************************************
 * Interface for WorkflowTimelineElement
 * **************************************************
 */
export interface WorkflowTimelineElement {

  id: number,
  parentId: number,
  duration: number,

  workflowName: string,
  jobId: string,
  specificStatus: string,
  startTime: string,

}
